var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[(_vm.ready)?_c('Navbar'):_vm._e(),_c('div',{staticClass:"app-main pt-4"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }